import { useEffect, useState } from "react";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { disablePush, enablePush, getPushState } from "@/lib/push";

export const PushButton = () => {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPushState().then(setEnabled);
  }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      if (enabled) {
        await disablePush();
        setEnabled(false);
        toast.success("اعلان تغییر قیمت غیرفعال شد");
      } else {
        await enablePush();
        setEnabled(true);
        toast.success("اعلان تغییر قیمت فعال شد — هنگام تغییر نرخ، مطلع می‌شوید");
      }
    } catch (e) {
      toast.error(e?.message || "فعال‌سازی اعلان ناموفق بود");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid="push-toggle-btn"
      onClick={toggle}
      disabled={busy}
      title="اعلان تغییر قیمت"
      aria-label="اعلان تغییر قیمت"
      className={`flex h-9 w-9 items-center justify-center rounded-full border transition-colors duration-300 ${
        enabled ? "border-amber-400 bg-amber-500 text-black" : "border-amber-500/30 text-amber-200 hover:bg-amber-500/10"
      }`}
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : enabled ? <Bell className="h-4 w-4" /> : <BellOff className="h-4 w-4" />}
    </button>
  );
};
